import { EventType } from '@ltvco/refresh-lib/v2';

export type ConsolidatedFilterFormInfo = {
  fName: string;
  mName: string;
  lName: string;
  location: string;
  birthMonth: string;
  birthYear: string;
  deathMonth: string;
  deathYear: string;
  title: string;
  company: string;
  level: string[];
  industry: string;
  company_size_min: string;
  company_size_max: string;
  country: string;
  eventType: EventType;
  eventMonth: string;
  eventYear: string;
  advancedSearch: boolean;
  selectedSources: Record<string, boolean>;
};

export type PersonSearchParamsv2 = {
  fullName?: string;
  fName?: string;
  lName?: string;
  title?: string;
  company?: string | null;
  level?: string[];
  industry?: string;
  company_size_min?: string;
  company_size_max?: string;
  birthMonth?: string | null;
  birthYear?: string | null;
  deathMonth?: string | null;
  deathYear?: string | null;
  address?: string | null;
  mName?: string;
  city: string;
  state: string;
  age: string;
  isDeceased?: boolean;
  location?: string;
};

export interface RapidsSearchData {
  city: string;
  county?: string;
  entries: number;
  fips?: string;
  fn?: string;
  ln?: string;
  name?: string;
  secondary: string;
  state: string;
  street_line: string;
  type: string;
  zipcode: string;
}

export const viewTypes = {
  TABLE: 'table' as const,
  GRID: 'grid' as const,
};
